var _radialGradient, _linearGradient, _linearGradient2, _linearGradient3, _g, _linearGradient4, _g2, _linearGradient5, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgItaly10ELotto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 400 400",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 69.82,
    cy: -1429.898,
    r: 137.488,
    fx: 69.771,
    fy: -1429.904,
    gradientTransform: "matrix(.5064 .8629 -.5509 .322 -718.266 526.298)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.086,
    stopColor: "#dff5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247,
    stopColor: "#9ab4ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    stopColor: "#3c5b8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.588,
    stopColor: "#163870"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#18315e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a2b50"
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 61.157,
    y1: 261.395,
    x2: 64.225,
    y2: 300.404
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dff5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.166,
    stopColor: "#9ab4ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.406,
    stopColor: "#3c5b8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515,
    stopColor: "#163870"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.753,
    stopColor: "#18315e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a2b50"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 181.53,
    y1: 289.265,
    x2: 215.29,
    y2: 119.596
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a2b50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#18315e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#163870"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#3c5b8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.869,
    stopColor: "#9ab4ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dff5ff"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientUnits: "userSpaceOnUse",
    x1: 200.366,
    y1: 259.082,
    x2: 200.366,
    y2: 127.708
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dff5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.131,
    stopColor: "#9ab4ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#3c5b8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.406,
    stopColor: "#163870"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697,
    stopColor: "#18315e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a2b50"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m60.532 193.485 15.547-11.205-16.069 72.786 6.949 7.991 26.318-3.214 10.162-10.162 22.496-110.221c3.214-20.325-15.026-23.538-23.017-21.367-8.078 2.171-32.745 22.496-42.907 31.008-10.683 8.599-23.625 17.111-25.71 25.71-3.214 14.939 13.376 26.752 26.231 18.674z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.851 249.16c-6.949-.521-20.411 0-20.411 0l-10.162 10.162-26.318 3.735-6.949-7.991-17.198 2.171c-21.454 2.693-22.496 35.351-.521 34.83 7.47 0 62.19-5.906 73.481-7.47 22.583-2.779 25.797-33.266 8.078-35.438z",
    fill: "url(#b)"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 22.424,
    y1: 184.435,
    x2: 116.336,
    y2: 244.993
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1f7dbc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.086,
    stopColor: "#1e76b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.219,
    stopColor: "#1b629e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.381,
    stopColor: "#17427b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425,
    stopColor: "#163870"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.586,
    stopColor: "#163870"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    stopColor: "#184a84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.787,
    stopColor: "#1d6fad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.858,
    stopColor: "#1f7dbc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1b5e9a"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m44.464 265.75 22.496-2.693 21.454-100.059-31.095 23.538c-4.256 3.214-10.162 2.171-13.376-2.171-3.214-4.777-2.171-10.683 2.171-14.418l55.762-42.82c4.864-3.214 10.683-2.171 13.376 2.693 1.65 2.693 2.171 5.385 1.65 8.599L93.277 260.452l24.146-2.693c5.385-.521 9.641 3.214 9.641 8.599s-4.256 10.162-9.641 10.683l-72.96 7.991c-5.385.521-9.641-3.214-9.641-8.599.521-5.298 4.864-10.162 9.641-10.683z",
    fill: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.348 279.734c-98.148-3.735-68.617-170.24 30.053-169.11 101.883 1.042 71.31 173.366-30.053 169.11zm4.864-36.393c-45.079-2.171-24.667-96.845 20.933-96.324 47.163.521 25.71 98.409-20.933 96.324z",
    fill: "#a1acb4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.443 107.931c-98.669-1.042-128.201 165.897-29.531 169.632 100.841 4.256 131.415-168.068 29.531-169.632zm-30.574 161.554c-87.986-3.214-58.455-153.65 29.531-152.521 91.2 1.129 61.147 156.342-29.531 152.521z",
    fill: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.358 136.768c-55.241-1.563-79.908 110.829-25.189 114.043 56.283 3.735 81.993-112.393 25.189-114.043zM189.775 241.17c-45.079-2.171-24.667-96.845 20.933-96.324 46.642.521 25.189 98.496-20.933 96.324z",
    fill: "url(#e)"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    gradientUnits: "userSpaceOnUse",
    x1: 131.7,
    y1: 161.38,
    x2: 275.802,
    y2: 228.025
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#163870"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.176,
    stopColor: "#1f7dbc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.227,
    stopColor: "#1e76b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304,
    stopColor: "#1b629e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.399,
    stopColor: "#17427b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425,
    stopColor: "#163870"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.631,
    stopColor: "#163870"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.725,
    stopColor: "#18447d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#1b5e9a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1f7dbc"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M183.869 269.485c-87.986-3.214-58.455-153.65 29.531-152.521 91.2 1.129 61.147 156.342-29.531 152.521zm3.214-18.674c-54.72-3.214-29.531-115.607 25.189-114.043 56.891 1.65 31.182 117.778-25.189 114.043z",
    fill: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m283.668 231.007-26.318 23.017v7.991l22.496-18.761c-2.171 13.897 3.214 27.273 20.933 28.923 27.881 3.214 55.762-17.111 72.96-36.914l-4.256-3.214s-25.71 29.966-57.412 32.658c-20.411 1.563-22.496-10.683-19.282-22.496 16.59 12.855 49.856 4.256 50.985-17.111.521-12.855-13.984-18.24-24.667-18.24-9.641 0-20.411 3.735-26.839 10.683-3.214 3.301-6.514 8.078-8.599 13.463zm10.683 5.298c1.65-4.256 3.735-7.991 5.385-10.683 6.427-9.641 13.984-14.418 23.017-13.376 26.839.521-2.085 43.342-28.402 24.059z",
    fill: "#c56426"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItaly10ELotto);
export default __webpack_public_path__ + "static/media/italy_10e_lotto.1145184fb6a3f66c6fbbda0f29f82e31.svg";
export { ForwardRef as ReactComponent };